import Modal from 'react-modal';
import { FiSend, FiXCircle } from 'react-icons/fi';

import { useEffect, useState } from 'react';
import { Container } from './styles';

const customStyles = {
  content: {
    width: '98%',
    maxWidth: 800,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
  },
};

Modal.setAppElement('#root');

interface Props {
  show: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSend: (email: string) => void;
}
export function ModalEnviarPorEmail({ show, onClose, onSend }: Props) {
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (!show) {
      setEmail('');
    }
  }, [show]);

  return (
    <Modal isOpen={show} style={customStyles} contentLabel="Enviar por e-mail">
      <Container>
        <div className="card-header text-white bg-danger">
          <p>Enviar por e-mail</p>
        </div>
        <div className="card-body">
          <label>Email de envio</label>
          <input
            type="text"
            className="form-control"
            id="email"
            name="email"
            required
            placeholder="Email de envio"
            value={email}
            // eslint-disable-next-line prettier/prettier
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              onSend(email);
            }}
          >
            <FiSend />
            Enviar
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            <FiXCircle />
            Cancelar
          </button>
        </div>
      </Container>
    </Modal>
  );
}
